import { createSlice } from "@reduxjs/toolkit"
import {
  addItemGroup,
  deleteItemGroup,
  getItemGroupDetails,
  getItemGroups,
  getItemGroupsList,
  updateItemGroup,
  updateItemGroupStatus,
} from "store/actions/itemGroupsAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  itemGroups: [],
  itemGroupsList: [],
  itemGroupDetails: {},
}

const usersSlice = createSlice({
  name: "item groups", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH ALL ITEM GROUPS
    builder
      .addCase(getItemGroups.pending, state => {
        state.loading = true
      })
      .addCase(getItemGroups.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.itemGroups = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getItemGroups.rejected, (state, action) => {
        state.loading = false
      })

    // ALL LIST
    builder
      .addCase(getItemGroupsList.pending, state => {
        state.loading = true
      })
      .addCase(getItemGroupsList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.itemGroupsList = data
        }
      })
      .addCase(getItemGroupsList.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE STATUS
    builder
      .addCase(updateItemGroupStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateItemGroupStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.itemGroups = state.itemGroups.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateItemGroupStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    //   DELETE
    builder
      .addCase(deleteItemGroup.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteItemGroup.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.itemGroups = state.itemGroups.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteItemGroup.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD
    builder
      .addCase(addItemGroup.pending, state => {
        state.isLoading = true
      })
      .addCase(addItemGroup.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addItemGroup.rejected, (state, action) => {
        state.isLoading = false
      })

    // DETAILS
    builder
      .addCase(getItemGroupDetails.pending, state => {
        state.loading = true
        state.itemGroupDetails = {}
      })
      .addCase(getItemGroupDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.itemGroupDetails = data
        }
      })
      .addCase(getItemGroupDetails.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE
    builder
      .addCase(updateItemGroup.pending, state => {
        state.isLoading = true
      })
      .addCase(updateItemGroup.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateItemGroup.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
